import { checkNull2String, checkNull2Int } from "./ItemTools"

export class ReqPositionDemandList {
    constructor({ companyId, companyName = "", workPlace = "", workAddress = ""
        , job = "", jobType = "", jobDemand = "", start, limit }) {
        this.companyId = companyId
        this.companyName = companyName
        this.workPlace = workPlace
        this.workAddress = workAddress
        this.job = job
        this.jobType = jobType
        this.jobDemand = jobDemand
        this.start = start
        this.limit = limit
    }

    fromJson(jsonData) {
        if (this.companyId === undefined)
            this.companyId = jsonData.companyId
        this.companyName = jsonData.companyName
        this.workPlace = jsonData.workPlace
        this.workAddress = jsonData.workAddress
        this.job = jsonData.job
        this.jobType = jsonData.jobType
        this.jobDemand = jsonData.jobDemand
    }
}

export class ReqPositionDemandDetail {
    constructor({ customerContractId, customerPositionId }) {
        this.customerContractId = customerContractId
        this.customerPositionId = customerPositionId
    }
}